import { createContext, useContext } from 'react';
import type { Recipe } from '../../../services/recipes/recipesService';

export interface RecipeViewerContextValue {
  restaurantId: string;
  recipes: Recipe[];
  isStale: boolean;
  isRefreshing: boolean;
  lastUpdated: number | null;
  refresh: () => void;
}
export const RecipeViewerContext = createContext<RecipeViewerContextValue | null>(null);
export function useRecipeViewer() {
  const value = useContext(RecipeViewerContext);
  if (!value) throw new Error('Recipe viewer context is missing');
  return value;
}
